import request from '@/utils/request';
import axios from "axios";

const TEST_URL = "http://127.0.0.1:"
const TRUE_URL = "http://154.8.219.40:"

const MAIN_SERVICE_PORT = 8082
const REPORT_SERVICE_PORT = 8086


// user
export function userlist_name(params) {
    return request({ url: process.env.VUE_APP_URL_MAIN_SERVICE_TASK + `/get_userlist_name`, method: 'get', params })
}

export function get_task(params) {
    return  request({ url: process.env.VUE_APP_URL_MAIN_SERVICE_TASK + `/get_task?skip=`+params, method: 'get', params })
}

/*
测试使用
*/
export function get_task_record() {
    return  request({ url: process.env.VUE_APP_URL_REPORT_SERVICE + `/task/record`, method: 'get'})
}

export function delete_task(params) {
    const data =params;
    return request({ url:( process.env.VUE_APP_URL_MAIN_SERVICE_TASK + `/delete_task?task_id=`+data), method: 'delete', params })
}


//axios.defaults.withCredentials = true; // 设置withCredentials为true
export function push_task(params) {
    const data = params;
    return axios.post( process.env.VUE_APP_URL_MAIN_SERVICE_TASK + `/push_task`,data);
}

export function update_task(params) {
    const data = params;
    return axios.post(process.env.VUE_APP_URL_MAIN_SERVICE_TASK + '/update_task',data);
}
axios.defaults.withCredentials = false;
export function task_chart(params) {
    return request({ url: `/api_task/task_chart`, method: 'get' })
}

export function photo_save(formData) {
    return axios.post(process.env.VUE_APP_URL_MAIN_SERVICE_TASK + `/upload`,  formData ,{ headers:{
        'Content-Type': 'multipart/form-data' // 设置请求头为 multipart/form-data
    },});

}
